"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ZendeskForm;

var _react = _interopRequireWildcard(require("react"));

var _SelectField = _interopRequireDefault(require("./form/SelectField"));

var _TextField = _interopRequireDefault(require("./form/TextField"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _validateEmail = _interopRequireDefault(require("../helpers/validateEmail"));

var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));

var _lodash = require("lodash");

var _lowercaseKeys = _interopRequireDefault(require("../helpers/lowercaseKeys"));

var _groupObjectsByPropertyValue = _interopRequireDefault(require("../helpers/groupObjectsByPropertyValue"));

var _wholesaleCustomersNear = _interopRequireDefault(require("../api/wholesaleCustomersNear"));

var _verifyCaptcha = _interopRequireDefault(require("../api/verifyCaptcha"));

var _submitZendesk = _interopRequireDefault(require("../api/submitZendesk"));

var _convertStates = require("../helpers/convertStates");

var _styles = require("@material-ui/core/styles");

var _theme = _interopRequireDefault(require("../theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ZendeskForm(_ref) {
  var _useState21;

  var loading = _ref.loading,
      ticketID = _ref.ticketID,
      isStaging = _ref.isStaging,
      apiBrand = _ref.apiBrand,
      formBrand = _ref.formBrand,
      formTag = _ref.formTag,
      productTypeOptions = _ref.productTypeOptions,
      header = _ref.header,
      Header = _ref.header,
      manualStores = _ref.manualStores,
      aboutInventoryNode = _ref.aboutInventoryNode,
      AboutInventoryNode = _ref.aboutInventoryNode,
      aboutPressNode = _ref.aboutPressNode,
      AboutPressNode = _ref.aboutPressNode,
      aboutWholesaleNode = _ref.aboutWholesaleNode,
      AboutWholesaleNode = _ref.aboutWholesaleNode,
      aboutProductSupportNode = _ref.aboutProductSupportNode,
      AboutProductSupportNode = _ref.aboutProductSupportNode,
      inquiryTypeOptionsOverride = _ref.inquiryTypeOptionsOverride,
      brandTheme = _ref.brandTheme,
      className = _ref.className;
  var handleLoading = loading;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      formError = _useState2[0],
      setFormError = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      submittedFormId = _useState4[0],
      setFormSubmitted = _useState4[1];

  var _useState5 = (0, _react.useState)(ticketID),
      _useState6 = _slicedToArray(_useState5, 2),
      ticketFormId = _useState6[0],
      setTicketFormId = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      captcha = _useState8[0],
      setCaptcha = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      captchaVerified = _useState10[0],
      setCaptchaVerified = _useState10[1];

  var _useState11 = (0, _react.useState)(''),
      _useState12 = _slicedToArray(_useState11, 2),
      subjectLine = _useState12[0],
      setSubjectLine = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      formLoading = _useState14[0],
      setFormLoading = _useState14[1];

  var recaptchaRef = /*#__PURE__*/(0, _react.createRef)();
  var captchaKey = '6LfxrkYdAAAAAGGWVpFvU9QlizA5JymHi17Z4bm4';

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      storesByState = _useState16[0],
      setStoresByState = _useState16[1];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = _slicedToArray(_useState17, 2),
      availableStates = _useState18[0],
      setAvailabeStates = _useState18[1];

  var allLoaded = availableStates && ticketFormId && productTypeOptions; //HANDLE LOADING

  (0, _react.useEffect)(function () {
    if (allLoaded) {
      handleLoading(false);
    }
  }, [handleLoading, allLoaded]);
  var brandTag = isStaging ? 'devtest' : formTag;

  var oncaptchachange = function oncaptchachange() {
    var recaptchaValue = recaptchaRef.current.getValue();
    setCaptcha(recaptchaValue);
  };

  (0, _react.useEffect)(function () {
    if (captcha) {
      (0, _verifyCaptcha.default)(captcha).then(function (response) {
        if (response.success) {
          setCaptchaVerified(true);
        }
      });
    }
  }, [captcha]);

  var sanitizeLabel = function sanitizeLabel(labelString, cityString) {
    var properLabel = labelString.replace('- ' + cityString, '') + ' - ' + cityString;
    return properLabel;
  };

  var storeOptionsByState = function storeOptionsByState(state) {
    var options = [];
    storesByState[state].map(function (el, i) {
      if ((0, _lodash.get)(el, 'address', false) && (0, _lodash.get)(el, 'city', false) && (0, _lodash.get)(el, 'state', false) && (0, _lodash.get)(el, 'zip', false) && (0, _lodash.get)(el, 'name', false) && (0, _lodash.get)(el, 'id', false)) {
        options.push({
          label: sanitizeLabel(el.name, el.city),
          value: sanitizeLabel(el.name, el.city),
          id: i,
          storeId: el.id,
          address: "".concat(el.address, ", ").concat(el.city, " ").concat(el.state, ", ").concat(el.zip)
        });
      }

      return false;
    });
    var formattedOptions = (0, _lodash.orderBy)((0, _lodash.uniqBy)(options, 'label'), ['label'], ['asc']);
    formattedOptions.push({
      label: 'Other',
      value: 'Other',
      id: formattedOptions.length + 1
    });
    return formattedOptions;
  };

  var formatStoreData = function formatStoreData(stores) {
    var theData = (0, _lowercaseKeys.default)(stores);
    var theDataGrouped = (0, _groupObjectsByPropertyValue.default)(theData, 'state');
    var allStates = Object.keys(theDataGrouped);

    var formatStates = function formatStates(states) {
      var options = [];
      Object.keys(states).forEach(function (i) {
        options.push({
          label: (0, _convertStates.convertAbbreviation)(states[i]),
          value: states[i]
        });
      });
      return options;
    };

    setStoresByState(theDataGrouped);
    setAvailabeStates(formatStates(allStates));
  };

  (0, _react.useEffect)(function () {
    if (manualStores) {
      formatStoreData(manualStores);
    } else {
      (0, _wholesaleCustomersNear.default)('60640', apiBrand, 1000, 0).then(function (data) {
        formatStoreData(data.data);
      });
    }
  }, [manualStores]); //SOME ZENDESK DEFAULTS

  var formDefaults = {
    Brand: formBrand,
    Tags: [brandTag],
    BrandId: 360000177294
  }; //SET UP FORM FIELDS

  var _useState19 = (0, _react.useState)((_useState21 = {
    InquiryType: {
      value: '',
      required: true,
      error: false
    },
    Product: {
      value: '',
      required: false,
      error: false
    },
    State: {
      value: '',
      required: true,
      error: false
    },
    DispensaryName: {
      value: '',
      required: false,
      error: false
    },
    DispensaryID: {
      value: '',
      required: false,
      error: false
    },
    OtherDispensaryName: {
      value: '',
      required: false,
      error: false
    },
    Comments: {
      value: '',
      required: true,
      error: false
    },
    Name: {
      value: '',
      required: true,
      error: false
    },
    Email: {
      value: '',
      required: true,
      error: false
    }
  }, _defineProperty(_useState21, "DispensaryName", {
    value: '',
    required: false,
    error: false
  }), _defineProperty(_useState21, "BatchNumber", {
    value: '',
    required: false,
    error: false
  }), _defineProperty(_useState21, "ProductName", {
    value: '',
    required: false,
    error: false
  }), _useState21)),
      _useState20 = _slicedToArray(_useState19, 2),
      newFormValues = _useState20[0],
      setNewFormValues = _useState20[1]; //FIELDS


  var inquiryTypeOptions = inquiryTypeOptionsOverride || [{
    value: 'General Inquiry',
    label: 'General Inquiry'
  }, {
    value: 'Product Support',
    label: 'Product Support'
  }, {
    value: 'Inventory Availability',
    label: 'Inventory Availability'
  }, {
    value: 'Wholesale',
    label: 'Wholesale'
  }, {
    value: 'Press',
    label: 'Press'
  }]; //CONDITIONS WHICH TO DISPLAY MESSAGING

  var isAboutInventory = newFormValues.InquiryType.value === 'Inventory Availability';
  var isAboutPress = newFormValues.InquiryType.value === 'Press';
  var isAboutWholesale = newFormValues.InquiryType.value === 'Wholesale';
  var isProductSupport = newFormValues.InquiryType.value === 'Product Support';
  var isStateFilledOut = newFormValues.State.value;
  var isOtherDispensary = newFormValues.DispensaryName.value === 'Other';
  (0, _react.useEffect)(function () {
    if (isProductSupport) {
      setTicketFormId(360005286554);
      setSubjectLine("".concat(formDefaults.Brand, " - Product Support"));
    } else {
      setTicketFormId(360005270154);
      setSubjectLine("".concat(formDefaults.Brand, " - General Inquiry"));
    }
  }, [isProductSupport]);
  (0, _react.useEffect)(function () {
    if (newFormValues.Product.value) {
      var ProductName = productTypeOptions.find(function (el) {
        return el.value === newFormValues.Product.value;
      });
      setNewFormValues(_objectSpread(_objectSpread({}, newFormValues), {}, {
        ProductName: _objectSpread(_objectSpread({}, newFormValues['ProductName']), {}, {
          value: ProductName.label
        })
      }));
    }
  }, [newFormValues.Product.value]);
  (0, _react.useEffect)(function () {
    if (newFormValues.DispensaryName.value) {
      var stores = storeOptionsByState(newFormValues.State.value);
      var storeId = (0, _lodash.find)(stores, {
        value: newFormValues.DispensaryName.value
      }).storeId;
      setNewFormValues(_objectSpread(_objectSpread({}, newFormValues), {}, {
        DispensaryID: _objectSpread(_objectSpread({}, newFormValues['DispensaryID']), {}, {
          value: storeId
        })
      }));
    }
  }, [newFormValues.DispensaryName.value]);
  (0, _react.useEffect)(function () {
    if (isOtherDispensary) {
      setNewFormValues(_objectSpread(_objectSpread({}, newFormValues), {}, {
        OtherDispensaryName: _objectSpread(_objectSpread({}, newFormValues['OtherDispensaryName']), {}, {
          required: true
        })
      }));
    } else {
      setNewFormValues(_objectSpread(_objectSpread({}, newFormValues), {}, {
        OtherDispensaryName: _objectSpread(_objectSpread({}, newFormValues['OtherDispensaryName']), {}, {
          required: false
        })
      }));
    }
  }, [isOtherDispensary]);
  (0, _react.useEffect)(function () {
    if (isProductSupport) {
      setNewFormValues(_objectSpread(_objectSpread({}, newFormValues), {}, {
        Product: _objectSpread(_objectSpread({}, newFormValues['Product']), {}, {
          required: true
        }),
        ProductName: _objectSpread(_objectSpread({}, newFormValues['State']), {}, {
          required: true
        }),
        DispensaryName: _objectSpread(_objectSpread({}, newFormValues['DispensaryName']), {}, {
          required: true
        }),
        State: _objectSpread(_objectSpread({}, newFormValues['State']), {}, {
          required: true
        })
      }));
    }
  }, [isProductSupport]);

  var handleInputSubmit = function handleInputSubmit(name, value) {
    if (value) {
      setNewFormValues(_objectSpread(_objectSpread({}, newFormValues), {}, _defineProperty({}, name, _objectSpread(_objectSpread({}, newFormValues[name]), {}, {
        value: value,
        error: false
      }))));
    }

    if (newFormValues[name].required && !value) {
      setNewFormValues(_objectSpread(_objectSpread({}, newFormValues), {}, _defineProperty({}, name, _objectSpread(_objectSpread({}, newFormValues[name]), {}, {
        value: false,
        error: 'This field is required'
      }))));
    }
  };

  var handleForm = function handleForm(e) {
    e.preventDefault();
    var formIssue = false;
    Object.keys(newFormValues).map(function (i) {
      if (!newFormValues[i].value && newFormValues[i].required) {
        formIssue = true;
        setNewFormValues(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, i, {
            required: true,
            value: false,
            error: 'This field is required'
          }));
        });
      } else {
        if (i === 'Email') {
          var valid = (0, _validateEmail.default)(newFormValues[i].value);

          if (!valid) {
            setNewFormValues(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, i, {
                required: true,
                error: 'Please enter a valid email'
              }));
            });
          }
        }
      }
    });

    if (formIssue || !captcha || !captchaVerified) {
      setFormError('Please fill out all of the required fields.');
    } else {
      var ticket = {
        ticket: {
          subject: subjectLine,
          comment: {
            body: newFormValues.Comments.value
          },
          requester: {
            name: newFormValues.Name.value,
            email: newFormValues.Email.value
          },
          ticket_form_id: ticketFormId,
          status: 'new',
          tags: formDefaults.Tags,
          brand_id: formDefaults.BrandId,
          custom_fields: [{
            id: 360037183493,
            value: formDefaults.Brand
          }, {
            id: 1260803781729,
            value: newFormValues.Product.value
          }, {
            id: 360037222274,
            value: newFormValues.ProductName.value
          }, {
            id: 5650959543579,
            value: newFormValues.State.value
          }, {
            id: 360037222254,
            value: newFormValues.DispensaryName.value
          }, {
            id: 360052062133,
            value: newFormValues.BatchNumber.value
          }, {
            id: 5650666644635,
            value: newFormValues.DispensaryID.value
          }]
        }
      };
      window.scrollTo(0, 0);
      setFormLoading(true);
      (0, _submitZendesk.default)(ticket).then(function (response) {
        if ((0, _lodash.get)(response, 'data.success')) {
          setFormSubmitted((0, _lodash.get)(response, 'data.mc_response.id'));
        } else {
          setFormError('There was a problem with your request, please double check your submission or try again later.');
        }

        setFormLoading(false);
      });
    }
  };

  var innerTheme = (0, _styles.createTheme)((0, _lodash.merge)({}, _theme.default, brandTheme));
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: innerTheme
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "contact-page",
    className: className
  }, header ? /*#__PURE__*/_react.default.createElement(Header, null) : /*#__PURE__*/_react.default.createElement("div", {
    id: "contact-header"
  }, /*#__PURE__*/_react.default.createElement("h1", null, "Contact Us")), /*#__PURE__*/_react.default.createElement("div", {
    className: "wrapper standard-padding contact-wrapper"
  }, !formLoading ? /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleForm
  }, submittedFormId ? /*#__PURE__*/_react.default.createElement("div", {
    className: "form-message success"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Thank you for reaching out! Your request", ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "brandColor"
  }, "#", submittedFormId), " has been received and will be reviewed by our Customer Care team as soon as possible."), /*#__PURE__*/_react.default.createElement("p", null, "An email will be sent to", ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "brandColor"
  }, newFormValues.Email.value), " with updates regarding your inquiry."), /*#__PURE__*/_react.default.createElement("p", null, "Please know that it may take 24-48 hours for our team to review, and respond to your request depending on your inquiry due to the volume of messages that we receive.")) : /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 0
  }, /*#__PURE__*/_react.default.createElement("p", {
    style: {
      marginBottom: '30px',
      marginTop: '30px'
    }
  }, "Please fill out all of the fields"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, formError && /*#__PURE__*/_react.default.createElement("div", {
    className: "form-message error"
  }, /*#__PURE__*/_react.default.createElement("p", null, formError)), /*#__PURE__*/_react.default.createElement(_SelectField.default, {
    label: "Inquiry Type",
    name: "InquiryType",
    options: inquiryTypeOptions,
    handleInputSubmit: handleInputSubmit,
    required: newFormValues.InquiryType.required,
    error: newFormValues.InquiryType.error,
    hasPlaceholder: "Please Select"
  })), isAboutInventory && (aboutInventoryNode ? /*#__PURE__*/_react.default.createElement(AboutInventoryNode, {
    formDefaults: formDefaults
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "form-message inventory"
  }, /*#__PURE__*/_react.default.createElement("p", null, formDefaults.Brand, " products can be found at", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "/store-locator",
    target: "_blank",
    className: "underline"
  }, "these locations"), ". Locations receive deliveries on a routine basis, please check back soon if the products you\u2019re looking for are currently unavailable."))), isAboutPress && (aboutPressNode ? /*#__PURE__*/_react.default.createElement(AboutPressNode, {
    formDefaults: formDefaults
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "form-message press"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.crescolabs.com/contact",
    className: "underline"
  }, "Click here"), ' ', "to contact us regarding Press Inquiries."))), isAboutWholesale && (aboutWholesaleNode ? /*#__PURE__*/_react.default.createElement(AboutWholesaleNode, {
    formDefaults: formDefaults
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "form-message wholesale"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.crescolabs.com/contact",
    className: "underline"
  }, "Click here"), ' ', "to contact us regarding about Wholesale."))), !isAboutInventory && !isAboutPress && !isAboutWholesale && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isProductSupport && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, aboutProductSupportNode ? /*#__PURE__*/_react.default.createElement(AboutProductSupportNode, {
    formDefaults: formDefaults
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "form-message product"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Check out our", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "/faq",
    target: "_blank",
    className: "underline"
  }, "FAQ Page"), ' ', "and", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "/products",
    target: "_blank",
    className: "underline"
  }, "Products Page"), ' ', "for common questions about products.")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_SelectField.default, {
    label: "Which product are you referring to?",
    fieldLabel: "Choose a Product",
    name: "Product",
    options: productTypeOptions,
    handleInputSubmit: handleInputSubmit,
    required: newFormValues.Product.required,
    error: newFormValues.Product.error,
    hasPlaceholder: "Please Select"
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_SelectField.default, {
    label: "In which State did you purchase the product?",
    fieldLabel: "Select a State",
    name: "State",
    options: availableStates,
    handleInputSubmit: handleInputSubmit,
    required: newFormValues.State.required,
    error: newFormValues.State.error,
    hasPlaceholder: "Please Select"
  })), isStateFilledOut && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_SelectField.default, {
    label: "Dispensary Name",
    name: "DispensaryName",
    fieldLabel: "Dispensary Name",
    handleInputSubmit: handleInputSubmit,
    options: storeOptionsByState(newFormValues.State.value),
    autocomplete: true,
    required: newFormValues.DispensaryName.required,
    error: newFormValues.DispensaryName.error,
    hasPlaceholder: "Start typing to search. If dispensary is not listed, type 'Other'",
    tooltip: "Start typing to search. If dispensary is not listed, type 'Other'"
  })), isOtherDispensary && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    rows: 1,
    label: "Other Dispensary Name",
    name: "Other DispensaryName",
    fieldLabel: "Other Dispensary Name",
    handleInputSubmit: handleInputSubmit,
    required: newFormValues.OtherDispensaryName.required,
    error: newFormValues.OtherDispensaryName.error,
    hasPlaceholder: "If your dispensary was not listed above, enter it here"
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    rows: 1,
    label: "Batch Number",
    name: "BatchNumber",
    fieldLabel: "Batch Number",
    handleInputSubmit: handleInputSubmit,
    required: newFormValues.BatchNumber.required,
    error: newFormValues.BatchNumber.error,
    tooltip: "The Batch Number is a unique series of letters and/or numbers used by the manufacturer as a means of identification. It is typically found on the bottom or back of the product."
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    rows: 1,
    label: "Name",
    name: "Name",
    fieldLabel: "Enter your name",
    handleInputSubmit: handleInputSubmit,
    required: newFormValues.Name.required,
    error: newFormValues.Name.error
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    rows: 1,
    label: "Email Address",
    name: "Email",
    fieldLabel: "Enter your email",
    handleInputSubmit: handleInputSubmit,
    required: newFormValues.Email.required,
    error: newFormValues.Email.error
  })), !isProductSupport && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_SelectField.default, {
    label: "State",
    fieldLabel: "Select a State",
    name: "State",
    options: availableStates,
    handleInputSubmit: handleInputSubmit,
    required: newFormValues.State.required,
    error: newFormValues.State.error,
    hasPlaceholder: "Please Select"
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    rows: 5,
    label: "How can we help?",
    name: "Comments",
    multiline: true,
    fieldLabel: "Type your inquiry here",
    handleInputSubmit: handleInputSubmit,
    required: newFormValues.Comments.required,
    error: newFormValues.Comments.error
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    style: {
      marginBottom: '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
    ref: recaptchaRef,
    sitekey: captchaKey,
    onChange: oncaptchachange
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "secondary",
    variant: "contained",
    type: "submit",
    onClick: handleForm,
    disableElevation: true,
    disabled: !captchaVerified
  }, "Submit"))))) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50vh'
    }
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    color: "secondary"
  })))));
}